<template>
  <div>
    <button @click="handleCall" class="btn-hotline c-btn-hotline">
      <span style="font-size: 12px !important;">Hotline:</span>
      <span style="color: #ffff !important;"> 02471001088</span>
    </button>
  </div>
</template>

<script>
import { getToken } from "@/utils/wapAuth";
export default {
  components: {},
  bodyClass: "btn-call",
  props: {},
  watch: {},
  data() {
    return {};
  },

  watch: {},
  methods: {
    getToken,
    handleCall() {
      window.location.href = "tel:02471001088";
    }
  }
};
</script>
<style lang="scss"></style>

<style scoped>
.btn-hotline {
  font-size: 20px;
  padding: 8px 13px;
  border-radius: 10px;
  color: #fff !important;
  font-weight: 700;
}
.dialog-menu-app {
  background: #f5f5f5;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  z-index: 2000;
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;

.column {
  flex-direction: column;
}

.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}
</style>
